// extracted by mini-css-extract-plugin
export default {"cls1":"TagElement-cls1_Bja","cls2":"TagElement-cls2_nBX TagElement-cls1_Bja"};